export default {
  // 'this' - $store
  byActionType: {
    // score (event) {
    //   const { extra, GamePeriod } = event
    //
    //   this.setIngameProperty({
    //     property: 'score',
    //     value: {
    //       home: extra['points-1'],
    //       away: extra['points-2']
    //     }
    //   })
    // }
  },
  // 'this' - $store
  byEventType: {
    'FINISH_PERIOD' (event) {
      this.setIngameProperty({
        property: 'sets',
        value: {
          home: event.ScoreHome,
          away: event.ScoreAway
        }
      })
    }
    // 'ADJUST_SETS' (event) {
    //   const { EventCode, extra, TeamNumber, Playtime, Timestamp } = event
    //
    //   this.setIngameProperty({
    //     property: 'sets',
    //     value: {
    //       home: event.ScoreHome,
    //       away: event.ScoreAway
    //     }
    //   })
    // }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
    /**
     * @return {string}
     */
    'POINT' (event) {
      const { eventInfo, extra, TeamNumber } = event
      const { value } = extra
      const { homeTeamTitle, awayTeamTitle } = this
      const teamTitle = TeamNumber === 1 ? homeTeamTitle : awayTeamTitle

      if (!eventInfo) return ''

      if (this.$i18n.locale !== 'ru') return `${value} ${eventInfo.title} / ${teamTitle}`

      if (value === 1) return `${value} Очко / ${teamTitle}`

      if (value < 5) return `${value} Очка / ${teamTitle}`

      if (value < 8) return `${value} Очков / ${teamTitle}`

      return `${value} ${eventInfo.title} / ${teamTitle}`
    },
    'FINISH_PERIOD' () {
      if (this.$i18n.locale === 'ru') return 'Конец фрейма'

      return 'Finish frame'
    },
    'START_PERIOD' () {
      if (this.$i18n.locale === 'ru') return 'Начало фрейма'

      return 'Start frame'
    },
    /**
     * @return {string}
     */
    'CANCEL' (event, relatedEvent) {
      const { homeTeamTitle, awayTeamTitle } = this
      const { eventInfo } = event
      const { title } = eventInfo
      const { EventCode, extra, TeamNumber } = relatedEvent
      const { team } = extra
      const notPointEvents = ['TIMEOUT', 'BALL_IN_GAME', 'FINISH_PERIOD']

      if (notPointEvents.includes(EventCode)) {
        return `${title}: ${this.getEventTitle(relatedEvent)}`
      }

      if (EventCode === 'POINT') {
        return `
          ${title}: 
          ${relatedEvent.eventInfo.title}, 
          ${extra[`points-${team}`]}, 
          ${TeamNumber === 1 ? homeTeamTitle : awayTeamTitle}
        `
      }

      return `${title}: ${this.getEventTitle(relatedEvent)}`
    }
  }
}
